import { useTranslation } from "react-i18next";
import { Badge, Checkbox, Grid, Text } from "@mantine/core";
import { CampaignInquiryQueryDataType } from "src/hooks/campaignInquiries";

import { FormItem } from "../../../FormItem";

export interface CampaignInquiryOutcomeProps {
    campaignInquiry: CampaignInquiryQueryDataType;
}

export const CampaignInquiryOutcome = ({ campaignInquiry }: CampaignInquiryOutcomeProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <>
            <Grid>
                <Grid.Col xs={12} sm={6} md={4}>
                    <Checkbox
                        label={t("campaign_outcome_includeimages")}
                        checked={campaignInquiry?.outcome?.includeImages}
                        disabled
                        onChange={() => {}}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={4}>
                    <Checkbox
                        label={t("campaign_outcome_includevideo")}
                        checked={campaignInquiry?.outcome?.includeVideo}
                        disabled
                        onChange={() => {}}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={4}>
                    <Checkbox
                        label={t("campaign_outcome_includesocialposts")}
                        checked={campaignInquiry?.outcome?.includeSocialPosts}
                        disabled
                        onChange={() => {}}
                    />
                </Grid.Col>
            </Grid>
            <Grid>
                <Grid.Col xs={12} sm={6} md={4}>
                    <FormItem label={t("campaign_outcome_hashtags")}>
                        {!campaignInquiry?.outcome?.hashtags?.length && <Text color="dimmed">-</Text>}
                        {(campaignInquiry?.outcome?.hashtags || []).map((hashtag, index) => (
                            <Badge key={`${index}${hashtag}`}>{hashtag}</Badge>
                        ))}
                    </FormItem>
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={4}>
                    <FormItem label={t("campaign_outcome_fbmentions")}>
                        {!campaignInquiry?.outcome?.fbMentions?.length && <Text color="dimmed">-</Text>}
                        {(campaignInquiry?.outcome?.fbMentions || []).map((mention, index) => (
                            <Badge key={`${index}${mention}`}>{mention}</Badge>
                        ))}
                    </FormItem>
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={4}>
                    <FormItem label={t("campaign_outcome_igmentions")}>
                        {!campaignInquiry?.outcome?.igMentions?.length && <Text color="dimmed">-</Text>}
                        {(campaignInquiry?.outcome?.igMentions || []).map((mention, index) => (
                            <Badge key={`${index}${mention}`}>{mention}</Badge>
                        ))}
                    </FormItem>
                </Grid.Col>
            </Grid>
        </>
    );
};
